import { Model } from 'echarts';
import ComponentModel from 'echarts/lib/model/Component';
import GlobalModel from 'echarts/types/src/model/Global';
import { ComponentOption, RoamOptionMixin } from 'echarts/types/src/util/types';

export interface RoamOption extends ComponentOption, RoamOptionMixin {
  mainType?: 'roam';

  /**
   * roam适用于view而非cartesian2d
   * 但是在任意Coord中，Roam的行为应是一致的
   * 为了使roam适用cartesian2d，需要进行额外处理
   */
  adaptAxis?: boolean;

  /**
   * zoom在不同设备上的表现差异很大
   * 为了解决这种差异，提供一个缩放倍率调整参数
   */
  zoomRatio?: number;

  panRatio?: number;
  /** 平移方向，默认为 'xy'，即同时双向平移
   *
   * - 'xy' 同时双向平移
   * - 'x' 仅允许 x 方向平移
   * - 'y' 仅允许 y 方向平移
   * - 'x|y' 允许 xy 方向平移，但同时只能平移一个方向，自动判断
   */
  panDirection: 'x|y' | 'x' | 'y' | 'xy';

  // 是否限制不超出画布，默认值true
  roamLimit?: boolean;

  // 是否禁用X方向的平移，默认值false
  banPanX?: boolean;

  // 是否禁用Y方向的平移，默认值false
  banPanY?: boolean;

  // 是否禁用缩放，默认值false
  banZoom?: boolean;
}

class RoamModel<Opts extends RoamOption = RoamOption> extends ComponentModel<Opts> {
  [x: string]: any;

  static type = 'roam';

  type = RoamModel.type;

  static defaultOption: RoamOption = {
    roam: true,
    zoom: 1,
    center: ['50%', '50%'],
    adaptAxis: false,
    panRatio: 1,
    panDirection: 'xy',
    zoomRatio: 1,
    roamLimit: true,
    banPanX: false,
    banPanY: false,
    banZoom: false
  };
}

export default RoamModel;
